// PremiumMenu.js

import React, { useState } from 'react';
import './PremiumMenu.css'; // Подключаем стили

import useStore from '../../../store';
import { useTranslation, Trans } from 'react-i18next';

function PremiumMenu({ store }) {

  const { t } = useTranslation();

  useStore(state=>state.render);
  const showPremiumMenu = useStore(state=>state.showPremiumMenu);

  const { ref } = store;
  const { telegram,menu, drawing, info, work, premium } = ref;
  const { game, user, bot, group } = info;

  const {
    premiumFeatures = [],
    premiumSubs = [],
  } = premium;

  const {
    askGroupPremium,
  } = work.methods;

  const {
    isAppleDevice,
  } = info.methods;

  const {
    delayPremiumMenu,
  } = menu.methods;

  const showcase = {
    menu: [
      // { id: 'advantages' },
      { id: 'group', group: true, 
      // { id: 'group', enter: 'group', 
        button_style: { backgroundColor: menu.methods.adjustColor('--tg-theme-button-color', '4eca7d'),},
        info_style: { backgroundColor: menu.methods.blendColors('--tg-theme-secondary-bg-color', '4eca7d', 0.2),},
      },
      { id: 'user', enter: 'user',
        button_style: { backgroundColor: menu.methods.adjustColor('--tg-theme-button-color', '40a7e3'),},
        info_style: { backgroundColor: menu.methods.blendColors('--tg-theme-secondary-bg-color', '40a7e3', 0.2),},
      },
      { id: 'info' },
      { id: 'help',},
    ],
    user: [
      {id: 'artist', price: 99, full_price: 125},
      {id: 'master', price: 199, full_price: 250},
      {id: 'help',},
    ],
    group: [
      {id: 'group_inside'},
      {id: 'workshop', price: 249, full_price: 330},
      {id: 'artschool', price: 499, full_price: 650},
      {id: 'help',},
    ],
  }

  showcase.user.forEach(plan=>{
    const locale = game?.locale || 'en';
    const botUsername = bot.username;
    const urlSetId = `subsPm_${botUsername}_${locale}`;
    
    const botInvoices = bot[urlSetId];

    let invoice = botInvoices?.plans?.[plan.id]?.month;

    const url = invoice?.url;
    const price = invoice?.amount || plan.price;
    const full_price = invoice?.full_price || plan.full_price;
    
    Object.assign(plan, {
      url,
      price,
      full_price,
      button_style: { backgroundColor: menu.methods.adjustColor('--tg-theme-button-color', '40a7e3'),},
      info_style: { backgroundColor: menu.methods.blendColors('--tg-theme-secondary-bg-color', '40a7e3', 0.2),},
      description_style: { fontSize: '14px',},
    })
  })

  // store.group.forEach(plan=>{
  //   const botUsername = bot.username;
  //   const urlSetId = `subsGroup_${botUsername}`;
  //   const planId = `${plan.id}_month`;
  //   const url = group[urlSetId]?.[planId];
  //   Object.assign(plan, {
  //     url,
  //     button_style: { backgroundColor: adjustColor('--tg-theme-button-color', '4eca7d'),},
  //     info_style: { backgroundColor:blendColors('--tg-theme-secondary-bg-color', '4eca7d', 0.2),},
  //     description_style: { fontSize: '14px',},
  //   })
  // })

  const plans = showcase[showPremiumMenu] || showcase.menu;

  if (premiumSubs.includes('beta')) {
    plans.unshift({id: 'beta'}) 
  } else if (premiumSubs.includes('halloween')) {
    plans.unshift({id: 'halloween'})
  } else if (premiumSubs.includes('new_year')) {
    plans.unshift({id: 'new_year'})
  } else if (premiumSubs.includes('moder')) {
    plans.unshift({id: 'moder'})
  } else if (premiumSubs.includes('guild')) {
    plans.unshift({id: 'guild'})
  }

  function ExternalLink ({ href, children }) {
    const handleClick = (event) => {

      event.preventDefault(); 

      if (!telegram.inBrowser && window.Telegram?.WebApp?.openLink) {
        window.Telegram.WebApp.openLink(href);
      } else {
        window.open(href, '_blank');
      }

      // window.open(href, '_blank');
      // if (window.Telegram?.WebApp?.openTelegramLink) {
      //   window.Telegram.WebApp.openTelegramLink(href);
      // } else 
 
    };
  
    return (
      <a 
        href={href} 
        onClick={handleClick}
        style={{ color: 'var(--tg-theme-link-color)' }}
      >
        {children}
      </a>
    );
  }

  return (
    <>
      <div className="overlay-background" onClick={() => useStore.setState({showPremiumMenu: false})}></div>
      <div className="premium-menu touch-active">
        <span className="premium-menu-title">{t(`store.title.${showPremiumMenu}`, group)}</span>
        {plans.map((plan) => (
          <div key={plan.id} className="premium-item" style={plan.info_style}>
            <div className="premium-info" >
              <div className="premium-name">{premiumSubs.includes(plan.id) ? '✅' : ''}{t(`store.${plan.id}.name`)}</div>
                <p className="premium-description" style={plan.description_style}>
                  <Trans 
                    i18nKey={`store.${plan.id}.description`} 
                    values={{
                      ...group, 
                      price: plan.price, 
                      full_price: plan.full_price 
                    }}
                    components={{ 
                      s: <s />,
                      a: <ExternalLink href={t(`store.${plan.id}.url`)} />
                     }}
                  />
                </p>
            </div>
            { plan.enter &&
              (
                <button
                className="wide-button"
                onClick={() => delayPremiumMenu(plan.enter, 10)}
                style={plan.button_style}
              >
                {t(`store.${plan.id}.button_text`, { price: plan.price })}
              </button>
              )
            }
            { plan.url &&
              (
                <button
                className="wide-button"
                onClick={() => window.open(plan.url, '_self')}
                style={plan.button_style}
              >
                <Trans
                  i18nKey={`store.${plan.id}.button_text`}
                  values={{ 
                    price: plan.price, 
                    full_price: plan.full_price 
                  }}
                  components={{ s: <s /> }}
                >
                </Trans>
              </button>
              )
            }
            {plan.group &&  (
              <button
              className="wide-button"
              style={{
                backgroundColor: 'var(--tg-theme-destructive-text-color)',
              }}
              onClick={()=>{
                askGroupPremium();
                setTimeout(() => {
                  window.Telegram.WebApp.close();
                }, 300);
              }}
            >
              <Trans
                i18nKey={`store.${plan.id}.button_text`}
                values={{ 
                  price: plan.price, 
                  full_price: plan.full_price 
                }}
                components={{ s: <s /> }}
              />
            </button>
            )}

          </div>
        ))}
        <button 
        className="gray-button" 
        onClick={() => useStore.setState(state=>({showPremiumMenu: state.showPremiumMenu === 'menu' ? false : 'menu'}))}
        >
          {t(`store.back_button_text.${showPremiumMenu}`)}
        </button>
      </div>
    </>
  );
}

export default PremiumMenu;